import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Sunrise } from "lucide-react";
import { api } from "@/lib/api";

export function DeepStreak() {
  const [s, setS] = useState<any>(null);
  useEffect(() => { api.get("/deep/streak").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return null;
  const msg = s.today_done ? "You've read today. Lovely." : s.current ? "Read a chapter today to keep it going." : "Read a chapter and tap \u201cI read this\u201d to start.";
  return (
    <section className="mb-10 flex flex-wrap items-center gap-6 rounded-3xl bg-gradient-to-br from-[#FFF3DF] to-[#FBF7EF] p-6 ring-1 ring-[#EBDDC4] sm:p-8" data-testid="deep-streak">
      <div className="flex items-center gap-4">
        <motion.span animate={s.today_done ? { y: [0, -3, 0] } : {}} transition={{ repeat: Infinity, duration: 3 }} className="flex h-14 w-14 items-center justify-center rounded-2xl bg-amber-300 text-amber-900 shadow-inner"><Sunrise className="h-7 w-7" /></motion.span>
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-amber-800">Chapter a day</p>
          <p className="font-display text-4xl font-semibold text-slate-900" data-testid="deep-streak-current">{s.current} {s.current === 1 ? "day" : "days"}</p>
          <p className="text-sm text-slate-600" data-testid="deep-streak-msg">{msg}</p>
        </div>
      </div>
      <div className="flex gap-2" data-testid="deep-streak-week">
        {s.week.map((d: any) => (
          <span key={d.date} className="flex flex-col items-center gap-1 text-[11px] font-semibold text-slate-500" data-testid={`deep-streak-day-${d.date}`} data-done={d.done ? "yes" : d.grace ? "grace" : "no"}>
            <span className={`flex h-8 w-8 items-center justify-center rounded-full text-xs ${d.done ? "bg-amber-400 text-amber-950" : d.grace ? "border-2 border-dashed border-amber-400 text-amber-700" : d.today ? "border-2 border-amber-300 bg-white" : "bg-white/70"} ${d.future ? "opacity-50" : ""}`}>{d.done ? "\u2713" : d.grace ? "\u2661" : ""}</span>{d.label}
          </span>
        ))}
      </div>
      <div className="ml-auto text-right text-sm text-slate-600">
        <p data-testid="deep-streak-best">Best: <span className="font-semibold text-slate-900">{s.best}</span></p>
        <p data-testid="deep-streak-chapters">{s.chapters} {s.chapters === 1 ? "chapter" : "chapters"} read</p>
        <p className="text-xs text-slate-500">{s.grace_available ? "One grace day this week" : "Grace day used this week"}</p>
      </div>
    </section>
  );
}
